import axios from "../../Axios/axiosConfig";

export class PackageNameService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }

    getPackageNameAndVersion = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/packages/v0/device/${controlUnitId}/package/current`);
    }

}
